/**
 * Builds a complete HTML document for rendering contract HTML in an iframe.
 *
 * Using an iframe isolates the contract HTML from the app's Tailwind CSS,
 * which resets margins on <p>, <ol>, <ul> etc. Inside the iframe, the
 * template's inline styles are the only styles that apply, ensuring
 * faithful rendering of spacing, fonts, and layout.
 */
export function buildContractSrcDoc(html: string): string {
  return `<!DOCTYPE html>
<html><head><meta charset="utf-8">
<style>
  body {
    margin: 0;
    padding: 0;
    background: rgb(205, 205, 205);
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 2rem;
    gap: 2rem;
  }
  .page {
    background: white;
    width: 210mm;
    max-width: 100%;
    min-height: 297mm;
    padding: 20mm;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.15);
  }
  @media (max-width: 900px) {
    .page { padding: 10mm; }
  }
</style>
</head><body><div class="page">${html}</div></body></html>`
}
